import {
    DEALERLISTPARTNER_SUCCESS,
    DEALERLISTPARTNER_FAILED,
    RESET_DEALERLISTPARTNER,
    LOADING_DEALERLISTPARTNER,
    NETWORK_ERROR_DEALERLISTPARTNER
} from "../types/index";

import { partnerServices } from "../../config/axios";


const resetDealerListForPartner = () => {
    return { type: RESET_DEALERLISTPARTNER };
};


const partnerDealerListReq = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERLISTPARTNER });
    await partnerServices
        .post("dealerList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerDealerListsuccess(res.data));
                    break;
                default:
                    dispatch(partnerDealerListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERLISTPARTNER,
                payload: err
            });
        });
};


function partnerDealerListsuccess(data) {
    return {
        type: DEALERLISTPARTNER_SUCCESS,
        payload: data,
    };
}

function partnerDealerListFailed(data) {
    return {
        type: DEALERLISTPARTNER_FAILED,
        payload: data,
    };
}
export { resetDealerListForPartner, partnerDealerListReq }